module.exports = __webpack_public_path__ + "static/media/blueshape1.8aea6d38.png";